import { useMutation, useQueryClient } from "@tanstack/vue-query";
import OpportunityStage from "@/services/opportunity/opportunity-stage";
import type { RegisterOpportunityStage } from "@/dtos/OpportunityStage.dto";

export function useCreateOpportunityStage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: RegisterOpportunityStage) => {
      const result = await OpportunityStage.registerOpportunityStage(payload);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to create opportunity stage");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["opportunityStages"] });
    },
  });
}
